import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  deleteProjectMemberInvite,
  DeleteProjectMemberInviteInput,
} from '@/features/projects/shared/api/delete-project-member-invite';
import { getProjectMemberManagementSearchKey } from '@/features/projects/shared/hooks/use-search-project-member-management';

interface UseDeleteProjectMemberInviteMutationProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useDeleteProjectMemberInviteMutation({
  onSuccess,
  onError,
}: UseDeleteProjectMemberInviteMutationProps = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: DeleteProjectMemberInviteInput) =>
      deleteProjectMemberInvite(input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getProjectMemberManagementSearchKey({
          projectId: variables.projectId?.toString(),
        }),
      });
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
}
